import { render } from "./NcrmPrivacyPhoneLink.vue?vue&type=template&id=19d8d72e"
import script from "./NcrmPrivacyPhoneLink.vue?vue&type=script&lang=js"
export * from "./NcrmPrivacyPhoneLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__